<div class="failure-page">
  <mat-card class="failure-card">
    <div class="failure-icon-wrap">
      <mat-icon class="failure-icon" color="warn">highlight_off</mat-icon>
    </div>

    <h1 class="failure-title">{{ fulfilmentRejected ? "We couldn't book your campaign" : "Payment unsuccessful" }}</h1>

    <!-- Polling while webhook resolves the status -->
    <div class="status-polling" *ngIf="statusPolling">
      <app-data-loader [show]="true" message="Checking payment status…" size="medium" />
    </div>

    <!-- Initial load -->
    <div class="loader-centered" *ngIf="loading && !statusPolling">
      <app-data-loader [show]="true" message="Loading…" size="medium" />
    </div>

    <!-- Paid, but the order was rejected while booking: refund, no retry -->
    <ng-container *ngIf="!loading && !statusPolling && fulfilmentRejected">
      <p class="failure-subtitle" data-testid="fulfilment-rejected">
        Your payment went through, but the campaign could no longer be scheduled as ordered.
        Your payment will be refunded to your original payment method. You have not been charged
        for a campaign.
      </p>

      <div class="amount-box" *ngIf="amount != null">
        <span class="amount-label">Amount to be refunded</span>
        <span class="amount-value">{{ formatMoney(amount, currency) }}</span>
      </div>

      <div class="reason-box" *ngIf="failureMessage">
        <span class="reason-label">Reason</span>
        <p class="reason-text">{{ failureMessage }}</p>
      </div>

      <div class="actions">
        <button mat-flat-button color="primary" class="btn-primary" routerLink="/campaignbuilder">
          Build a new campaign
        </button>
        <button mat-stroked-button class="btn-secondary" routerLink="/orders">
          My orders
        </button>
      </div>
    </ng-container>

    <!-- Settled failure state -->
    <ng-container *ngIf="!loading && !statusPolling && !fulfilmentRejected">
      <p class="failure-subtitle">
        We couldn't complete your payment. Review the details below and try again.
      </p>

      <!-- Amount attempted -->
      <div class="amount-box" *ngIf="amount != null">
        <span class="amount-label">Amount</span>
        <span class="amount-value">{{ formatMoney(amount, currency) }}</span>
      </div>

      <!-- Failure reason -->
      <div class="reason-box" *ngIf="failureMessage">
        <span class="reason-label">Reason</span>
        <p class="reason-text">{{ failureMessage }}</p>
      </div>

      <!-- Informational hints for non-retryable states -->
      <div class="hint-box" *ngIf="!failureMessage && sessionId && !canRetry">
        <mat-icon>info</mat-icon>
        <p *ngIf="status === 'PAYMENT_INTENT_CREATED' || status === 'PROCESSING' || status === 'INITIATED'">
          This checkout is still active or processing. Open your payment page to continue, or start a new campaign.
        </p>
        <p *ngIf="status === 'SUCCEEDED'">This payment session already completed successfully.</p>
        <p *ngIf="attemptNumber != null && attemptNumber >= 5">Maximum retry attempts reached for this session.</p>
      </div>

      <p class="attempt-line" *ngIf="attemptNumber != null && canRetry">
        Attempt {{ attemptNumber }} of 5
      </p>

      <div class="actions">
        <button
          mat-flat-button
          color="primary"
          class="btn-primary"
          *ngIf="canRetry"
          (click)="retryPayment()">
          <mat-icon>refresh</mat-icon>
          Retry payment
        </button>
        <button mat-stroked-button class="btn-secondary" routerLink="/campaignbuilder">
          Back to campaign builder
        </button>
      </div>
    </ng-container>

  </mat-card>
</div>
